/* eslint-disable */
import {
  isToday,
  isYesterday,
  isThisWeek,
  isThisMonth,
  parseISO,
  isAfter,
  subWeeks,
} from 'date-fns';
import { v4 as uuidv4 } from 'uuid';

import Vuetify from '@/plugins/vuetify';

const exibirSeparadorData = (item, separadores) => {
  const createdAt = item.createdAt instanceof Date ? item.createdAt : parseISO(item.createdAt);

  if (isToday(createdAt)) {
    if (!separadores.hoje) {
      separadores.hoje = true;
      return '$vuetify.hoje';
    }
    return;
  }

  if (isYesterday(createdAt)) {
    if (!separadores.ontem) {
      separadores.ontem = true;
      return '$vuetify.ontem';
    }
    return;
  }

  if (isThisWeek(createdAt)) {
    if (!separadores.estaSemana) {
      separadores.estaSemana = true;
      item.separadorData = '$vuetify.estaSemana';
    }
    return;
  }

  if (isAfter(createdAt, subWeeks(new Date(), 1))) {
    if (!separadores.semanaPassada) {
      separadores.semanaPassada = true;
      return '$vuetify.semanaPassada';
    }
    return;
  }

  if (isThisMonth(createdAt)) {
    if (!separadores.esteMes) {
      separadores.esteMes = true;
      return '$vuetify.esteMes';
    }
    return;
  }

  if (!isThisMonth(createdAt)) {
    if (!separadores.anteriores) {
      separadores.anteriores = true;
      return '$vuetify.anteriores';
    }
    return;
  }
};

const filtrosFn = (item, filtro) => {
  if (filtro === '') {
    return true;
  }

  const { anterior, atual, key, referenciaCliente, referenciaInterna } = item;
  const campos = [
    anterior,
    atual,
    Vuetify.framework.lang.t(`$vuetify.${key}`),
    referenciaCliente,
    referenciaInterna,
  ];
  return campos.some((campo) =>
    typeof campo === 'string' ? campo.toUpperCase().match(filtro) : false
  );
};

const separadoresFn = (separadores) => (notificacoes, notificacao) => {
  const separadorData = exibirSeparadorData(notificacao, separadores);

  if (separadorData) {
    notificacoes.push({ separadorData, _id: uuidv4() });
  }
  notificacoes.push(notificacao);
  return notificacoes;
};

export default {
  getConfiguracoes(state) {
    return state.configuracoes;
  },

  /**
   * Separa os cards por período (atualizado hoje, esta semana, semana passada, etc...)
   */
  getNotificacoes(state) {
    const separadores = {
      hoje: false,
      ontem: false,
      estaSemana: false,
      semanaPassada: false,
      esteMes: false,
      anteriores: false,
    };

    return state.notificacoes
      .filter((item) => filtrosFn(item, state.filtro))
      .reduce(separadoresFn(separadores), []);
  },
};
